import React from 'react';
import { Navigate } from 'react-router-dom';
import { LoadingSpinner } from '@components/LoadingSpinner';
import { FeatureGate, FeatureGated } from '@featureFlags/index';
import AppsThemeBoundary from '../pages/Apps/AppsThemeBoundary';

/** Every app is an HTML page, so the apps routes need the HTML view gate as well. */
const AppsGated: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <FeatureGated gate={FeatureGate.OS_APPS} fallback={<Navigate to="/" replace />} pending={<LoadingSpinner />}>
    <FeatureGated gate={FeatureGate.OS_APP_HTML_VIEW} fallback={<Navigate to="/" replace />} pending={<LoadingSpinner />}>
      <AppsThemeBoundary>{children}</AppsThemeBoundary>
    </FeatureGated>
  </FeatureGated>
);

export default AppsGated;
